// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"924202eb","644":"97b85301"}[chunkId] + ".chunk.js";
};